<template>
  <div class="flex w-full h-full justify-items-center items-center">
    <vs-tooltip text="編集" position="bottom">
      <div
        class="flex justify-center items-center action-button-icon p-1"
        :class="{ disabled: actionDisabledExceptAdd }"
        @click.stop="onClickEdit(null)"
      >
        <vs-icon icon="edit" size="22px" />
      </div>
    </vs-tooltip>
    <vs-tooltip text="削除" position="bottom">
      <div
        class="flex justify-center items-center action-button-icon p-1"
        :class="{ disabled: actionDisabledExceptAdd }"
        @click.stop="onClickDelete(null)"
      >
        <vs-icon icon="delete_outline" size="22px" />
      </div>
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  name: "CellRendererRowActionButtons",
  methods: {
    // Clickされたrowの情報を返す
    onClickEdit() {
      this.params.edit(this.params.data);
    },
    onClickDelete() {
      this.params.delete(this.params.data);
    },
  },
  computed: {
    actionDisabledExceptAdd() {
      return this.params.data.action_disabled_except_add;
    },
    actionDisabledTransfer() {
      return this.params.data.action_disabled_transfer;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button-icon {
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
  &:hover {
    background: rgb(199, 199, 199);
  }
}
// #flag-col {
//   .img-flag--container {
//     img {
//       border: 1px #e2e2e2 solid;
//     }
//     width: 44px;
//     height: 44px;
//   }
// }
</style>
